import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function NaviMumbaiAirportCabService() {



    const cardData = {





keyword: "Navi Mumbai Airport Cab Service",

headingDescription: "Shreesha Tours & Travels provides professional Navi Mumbai Airport Cab Service for airport pickups, airport drop-offs, corporate travel, hotel transfers, business meetings, family vacations, one-way trips, round trips, and outstation travel across Maharashtra and nearby states. We offer a fleet of chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, Mini Bus, and premium vehicles to suit every travel requirement. Our experienced drivers, flight tracking, on-time airport pickups, clean and well-maintained vehicles, transparent pricing, doorstep service, and 24/7 customer support ensure a safe, comfortable, and hassle-free journey. Whether you are traveling for business, tourism, family functions, or long-distance road trips, Shreesha Tours & Travels delivers reliable Navi Mumbai Airport cab booking services with complete convenience and customer satisfaction.",

topPlaces: [
  {
    title: "Navi Mumbai Airport to Alibaug",
    description: "Alibaug is a popular coastal getaway known for beautiful beaches, Kolaba Fort, luxury resorts, water sports, and relaxing weekend holidays."
  },
  {
    title: "Navi Mumbai Airport to Matheran",
    description: "Matheran is a peaceful hill station famous for toy train rides, scenic viewpoints, lush forests, and its pollution-free environment."
  },
  {
    title: "Navi Mumbai Airport to Panchgani",
    description: "Panchgani is a beautiful hill destination known for Table Land, Sydney Point, strawberry farms, and breathtaking valley views."
  },
  {
    title: "Navi Mumbai Airport to Bhimashankar",
    description: "Bhimashankar is one of the twelve Jyotirlingas, surrounded by forests, waterfalls, and wildlife sanctuary, making it a perfect pilgrimage and nature destination."
  },
  {
    title: "Navi Mumbai Airport to Solapur",
    description: "Solapur is known for Siddheshwar Temple, Akkalkot Swami Samarth Temple, Pandharpur, and important religious and business destinations."
  },
  {
    title: "Navi Mumbai Airport to Ganpatipule",
    description: "Ganpatipule is a famous Konkan destination offering pristine beaches, the Swayambhu Ganpati Temple, coastal views, and peaceful surroundings."
  },
  {
    title: "Navi Mumbai Airport to Ahmednagar",
    description: "Ahmednagar is known for Ahmednagar Fort, Meherabad, Shani Shingnapur, and historical landmarks, making it a popular outstation route."
  },
  {
    title: "Navi Mumbai Airport to Satara",
    description: "Satara is famous for Kaas Plateau, Thoseghar Waterfalls, Sajjangad Fort, and beautiful Western Ghats landscapes."
  },
  {
    title: "Navi Mumbai Airport to Dapoli",
    description: "Dapoli is a scenic Konkan destination featuring Murud Beach, Karde Beach, Suvarnadurg Fort, dolphin spotting, and peaceful seaside resorts."
  },
  {
    title: "Navi Mumbai Airport to Ujjain",
    description: "Ujjain is a major pilgrimage city famous for Mahakaleshwar Jyotirlinga, Mahakal Lok, Ram Ghat, and other important spiritual attractions."
  }
],


"services": [
  {
    "name": "Navi Mumbai Airport Cab Service",
    "description": "Book Navi Mumbai Airport Cab Service for safe, comfortable, and punctual airport transfers with professional chauffeurs and well-maintained AC vehicles. We provide reliable airport pickup and drop services for domestic and international travelers with Sedan, Hyundai Aura, Swift Dzire, Ertiga, Innova, Innova Crysta, SUV, Tempo Traveller, and luxury vehicles. Enjoy 24x7 availability, flight tracking, luggage assistance, transparent pricing, and hassle-free transportation from any location in Mumbai, Navi Mumbai, Thane, Panvel, Kalyan, Dombivli, and nearby areas."
  },
  {
    "name": "Navi Mumbai Airport Taxi Service",
    "description": "Choose Navi Mumbai Airport Taxi Service for affordable and dependable airport transportation with experienced drivers and clean AC vehicles. Our taxi service offers timely pickups, comfortable rides, professional chauffeurs, and flexible booking options for business travelers, families, tourists, and corporate clients."
  },
  {
    "name": "Airport Cab Service Navi Mumbai",
    "description": "Hire Airport Cab Service Navi Mumbai for smooth airport transfers with punctual pickups, comfortable vehicles, and courteous chauffeurs. Whether you need an airport pickup or drop, we ensure a reliable travel experience with well-maintained cars and transparent pricing."
  },
  {
    "name": "Navi Mumbai Airport Taxi",
    "description": "Book Navi Mumbai Airport Taxi for convenient airport travel with professional drivers and premium AC vehicles. Enjoy stress-free transportation, luggage support, flight monitoring, and on-time arrivals for every airport journey."
  },
  {
    "name": "Navi Mumbai Airport Cab",
    "description": "Reserve Navi Mumbai Airport Cab for comfortable airport pickup and drop services with flexible scheduling and multiple vehicle options. Travel safely with experienced chauffeurs and enjoy a hassle-free airport transfer experience."
  },
  {
    "name": "Book Cab Service for Navi Mumbai Airport",
    "description": "Book Cab Service for Navi Mumbai Airport with instant confirmation, multiple vehicle choices, and reliable chauffeur-driven transportation. Our online reservation process makes airport travel quick, convenient, and completely hassle-free."
  },
  {
    "name": "Online Navi Mumbai Airport Cab Service",
    "description": "Choose Online Navi Mumbai Airport Cab Service for fast booking, secure reservations, transparent fares, and reliable airport transfers. Select your preferred vehicle and enjoy 24x7 airport transportation with professional drivers."
  },
  {
    "name": "Best Cab Service Navi Mumbai Airport",
    "description": "Choose the Best Cab Service Navi Mumbai Airport for premium airport transportation with punctual service, experienced chauffeurs, clean vehicles, affordable pricing, and comfortable travel for business and leisure passengers."
  },
  {
    "name": "Reliable Airport Cab Service Navi Mumbai",
    "description": "Hire Reliable Airport Cab Service Navi Mumbai for dependable airport pickup and drop solutions. Our trained drivers, quality vehicles, and timely service ensure a comfortable and stress-free airport transfer every time."
  },
  {
    "name": "Cheapest Cab Service Navi Mumbai Airport",
    "description": "Book the Cheapest Cab Service Navi Mumbai Airport without compromising on quality, safety, or comfort. Enjoy economical airport transfers with professional drivers, clean vehicles, transparent pricing, and reliable service."
  },
  {
    "name": "24x7 Navi Mumbai Airport Cab Service",
    "description": "Choose 24x7 Navi Mumbai Airport Cab Service for round-the-clock airport transportation. Whether your flight is early morning, late night, or during peak hours, our airport cabs are available whenever you need them."
  },
  {
    "name": "Late Night Airport Cab Service Navi Mumbai",
    "description": "Book Late Night Airport Cab Service Navi Mumbai for safe and reliable midnight airport transfers. Our experienced chauffeurs provide secure, punctual, and comfortable transportation for late-night arrivals and departures."
  },
  {
    "name": "Early Morning Airport Taxi Navi Mumbai",
    "description": "Reserve Early Morning Airport Taxi Navi Mumbai for timely airport departures with guaranteed punctual pickups. Reach the airport comfortably with professional chauffeurs and well-maintained AC vehicles."
  },
  {
    "name": "Corporate Cab Service Navi Mumbai Airport",
    "description": "Choose Corporate Cab Service Navi Mumbai Airport for executive airport transportation with premium vehicles, trained chauffeurs, punctual service, and customized travel solutions for business professionals and corporate organizations."
  },
  {
    "name": "Luxury Airport Cab Service Navi Mumbai",
    "description": "Book Luxury Airport Cab Service Navi Mumbai for premium airport transfers with executive-class vehicles, spacious interiors, professional chauffeurs, and a first-class travel experience for VIP guests and business executives."
  },
  {
    "name": "Airport Transfer Service Navi Mumbai",
    "description": "Hire Airport Transfer Service Navi Mumbai for seamless airport pickup and drop with flight tracking, luggage assistance, clean vehicles, and courteous drivers. We ensure reliable airport transportation with complete travel comfort."
  },
  {
    "name": "Innova Airport Cab Service Navi Mumbai",
    "description": "Book Innova Airport Cab Service Navi Mumbai for spacious airport transportation with extra luggage capacity and premium comfort. Ideal for families, corporate teams, and group travelers requiring reliable airport transfers."
  },
  {
    "name": "Sedan Airport Cab Service Navi Mumbai",
    "description": "Choose Sedan Airport Cab Service Navi Mumbai for economical and comfortable airport transportation. Our AC sedan vehicles are perfect for solo travelers, couples, and business professionals seeking efficient airport travel."
  },
  {
    "name": "SUV Airport Cab Service Navi Mumbai",
    "description": "Reserve SUV Airport Cab Service Navi Mumbai for spacious airport transfers with premium comfort, additional luggage space, and professional chauffeurs. Ideal for family vacations, business travel, and group transportation."
  },
  {
    "name": "Tempo Traveller Airport Service Navi Mumbai",
    "description": "Book Tempo Traveller Airport Service Navi Mumbai for group airport transfers with spacious seating and ample luggage capacity. Perfect for corporate teams, wedding guests, family groups, and tourist travel."
  },
  {
    "name": "Safe Airport Cab Service in Navi Mumbai",
    "description": "Choose Safe Airport Cab Service in Navi Mumbai for secure airport transportation with verified chauffeurs, sanitized vehicles, GPS-enabled travel, and dependable service available throughout the day and night."
  },
  {
    "name": "AC Taxi Service Navi Mumbai Airport",
    "description": "Book AC Taxi Service Navi Mumbai Airport for comfortable airport transfers in clean, air-conditioned vehicles with experienced chauffeurs, affordable fares, and timely pickup and drop services."
  },
  {
    "name": "One Way Airport Cab Service Navi Mumbai",
    "description": "Reserve One Way Airport Cab Service Navi Mumbai for affordable one-way airport transportation without return charges. Enjoy convenient pickup, professional drivers, and comfortable vehicles for hassle-free airport travel."
  },
  {
    "name": "Innova Crysta Navi Mumbai Airport Cab Service",
    "description": "Choose Innova Crysta Navi Mumbai Airport Cab Service for luxurious airport transfers with premium interiors, spacious seating, extra luggage capacity, and professional chauffeurs for executive and family travel."
  },
  {
    "name": "Innova Cab Navi Mumbai Airport Cab",
    "description": "Book Innova Cab Navi Mumbai Airport Cab for spacious and reliable airport transportation. Enjoy premium comfort, experienced drivers, flexible booking options, and smooth airport pickup and drop services for families, business travelers, and groups."
  }
],
"tableData": [
  ["Navi Mumbai Airport Cab Service", "Navi Mumbai Airport Taxi Service"],
  ["Airport Cab Service Navi Mumbai", "Navi Mumbai Airport Taxi"],
  ["Navi Mumbai Airport Cab", "Book Cab Service for Navi Mumbai Airport"],
  ["Online Navi Mumbai Airport Cab Service", "Best Cab Service Navi Mumbai Airport"],
  ["Reliable Airport Cab Service Navi Mumbai", "Cheapest Cab Service Navi Mumbai Airport"],
  ["24x7 Navi Mumbai Airport Cab Service", "Late Night Airport Cab Service Navi Mumbai"],
  ["Early Morning Airport Taxi Navi Mumbai", "Corporate Cab Service Navi Mumbai Airport"],
  ["Luxury Airport Cab Service Navi Mumbai", "Airport Transfer Service Navi Mumbai"],
  ["Innova Airport Cab Service Navi Mumbai", "Sedan Airport Cab Service Navi Mumbai"],
  ["SUV Airport Cab Service Navi Mumbai", "Tempo Traveller Airport Service Navi Mumbai"],
  ["Safe Airport Cab Service in Navi Mumbai", "AC Taxi Service Navi Mumbai Airport"],
  ["One Way Airport Cab Service Navi Mumbai", "Innova Crysta Navi Mumbai Airport Cab Service"],
  ["Innova Cab Navi Mumbai Airport Cab", ""]
],




whychoose: [
  {
    WhyChooseheading: "Professional Navi Mumbai Airport Cab Service",
    WhyChoosedescription: "Shreesha Travels provides dependable Navi Mumbai Airport cab services for airport pickups, drops, business travel, hotel transfers, family journeys, and outstation trips. Enjoy punctual service, comfortable vehicles, and experienced chauffeurs for a seamless travel experience."
  },
  {
    WhyChooseheading: "Timely Airport Transfers for Every Flight",
    WhyChoosedescription: "Whether your flight departs early in the morning or arrives late at night, our airport cab service is scheduled according to your travel plans to ensure smooth and hassle-free transfers."
  },
  {
    WhyChooseheading: "Choose the Right Vehicle for Your Journey",
    WhyChoosedescription: "Book Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles based on the number of passengers and luggage."
  },
  {
    WhyChooseheading: "Suitable for Personal, Corporate & Tourist Travel",
    WhyChoosedescription: "Our Navi Mumbai Airport taxi service is ideal for business executives, corporate clients, tourists, families, hotel guests, and visitors looking for comfortable airport transportation."
  },
  {
    WhyChooseheading: "Airport to City & Outstation Cab Booking",
    WhyChoosedescription: "Travel conveniently from Navi Mumbai Airport to Mumbai, Thane, Navi Mumbai, Pune, Lonavala, Nashik, Surat, Ahmedabad, Goa, and numerous destinations across India with private chauffeur-driven cabs."
  },
  {
    WhyChooseheading: "Experienced Drivers with Local Route Knowledge",
    WhyChoosedescription: "Our courteous chauffeurs are familiar with airport routes, city traffic, expressways, and interstate highways, ensuring safe travel, timely arrivals, and comfortable journeys."
  },
  {
    WhyChooseheading: "Sanitized, Air-Conditioned & Well-Maintained Cars",
    WhyChoosedescription: "Every vehicle is regularly serviced, cleaned, sanitized, and inspected before every booking to provide passengers with a safe, comfortable, and reliable airport transfer experience."
  },
  {
    WhyChooseheading: "Book Navi Mumbai Airport Cab Service with Shreesha Travels",
    WhyChoosedescription: "Enjoy transparent pricing, instant booking assistance, flexible travel options, and professional chauffeur-driven airport transportation for every travel requirement."
  }
]

};

const faqData = [
  {
    question: "Can I schedule a Navi Mumbai Airport cab before my flight?",
    answer: "Yes, you can reserve your airport cab in advance according to your departure or arrival schedule for a worry-free transfer."
  },
  {
    question: "Do you provide airport pickup after flight arrival?",
    answer: "Yes, our drivers coordinate according to your flight timing and provide convenient pickup service from Navi Mumbai Airport."
  },
  {
    question: "Which vehicles can I book for airport transfers?",
    answer: "You can choose from Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
  },
  {
    question: "Can I travel directly from Navi Mumbai Airport to another city?",
    answer: "Yes, we provide direct airport transfers to Pune, Nashik, Surat, Ahmedabad, Goa, Kolhapur, Aurangabad, and many other destinations."
  },
  {
    question: "Is the airport cab service available for business travellers?",
    answer: "Yes, our chauffeur-driven airport taxis are suitable for executives, corporate guests, business meetings, and official travel."
  },
  {
    question: "Are airport taxi services available throughout the day?",
    answer: "Yes, our Navi Mumbai Airport cab service operates 24x7 for scheduled pickups and drops based on your travel plans."
  },
  {
    question: "Can I reserve a round-trip airport taxi?",
    answer: "Yes, round-trip airport transportation can be arranged with flexible return schedules according to your itinerary."
  },
  {
    question: "What factors determine the airport cab fare?",
    answer: "The fare depends on the pickup or drop location, selected vehicle, travel distance, trip timing, tolls, parking charges, and additional travel requirements."
  },
  {
    question: "Will the chauffeur assist with my luggage?",
    answer: "Yes, our professional drivers help passengers with luggage during airport pickup and drop for a comfortable travel experience."
  },
  {
    question: "How can I book Navi Mumbai Airport Cab Service with Shreesha Travels?",
    answer: "Simply provide your flight details, travel date, pickup or destination address, passenger count, and preferred vehicle to receive a customized quotation and confirmed booking."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Akshay Mehra",
    feedback: "Excellent airport transfer service. The driver arrived before time, monitored our flight, and the entire journey was smooth from pickup to destination.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Bhavna Patel",
    feedback: "Very professional airport cab service. The car was spotless, the chauffeur was polite, and the booking process was quick and convenient.",
    rating: 5
  }
];




    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];














    return (
        <div>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/84.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default NaviMumbaiAirportCabService;